import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { AlertModal } from './AlertModal';

export const RedirectWithAlert = ({ to, delay = 7000 }) => {
  const [showAlert, setShowAlert] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAlert(false);
    }, delay);
    return () => clearTimeout(timer);
  }, [delay]);

  if (showAlert) {
    return (
      <AlertModal>
        There was an error saving your registration details. Please{' '}
        <a href={`/site/SPageServer${to}`}>start over</a> and try again.
      </AlertModal>
    );
  }

  return <Redirect to={to} />;
};

RedirectWithAlert.propTypes = {
  to: PropTypes.string.isRequired,
  delay: PropTypes.number,
};
